module.exports.MINUTES_15 = 1 / 96;
module.exports.MINUTES_30 = 1 / 48;



//////////////////
// WEBPACK FOOTER
// ./src/helper/times.js
// module id = 29
// module chunks = 0